import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {setUpdatedBeerAC} from 'store/beers/beerSlice';
import {Beer, IBeerSocialMediaStatistic} from 'typescript/models/Beer';
import {StatisticDateRangeType} from 'typescript/types/StatisticDateRangeType';

interface IState {
  singleBeer: Beer | null;
  socialMediaStatistics: {filters: StatisticDateRangeType; statistics: IBeerSocialMediaStatistic | null};
}

const initialState: IState = {
  singleBeer: null,
  socialMediaStatistics: {filters: ' ', statistics: null},
};

export const singleBeerNamespace = '[beer]';

const beerPreviewSlice = createSlice({
  name: singleBeerNamespace,
  initialState,
  reducers: {
    setSingleBeerAC: (state, action: PayloadAction<IState['singleBeer']>) => {
      state.singleBeer = action.payload;
    },
    setStatisticAC: (state, action: PayloadAction<IBeerSocialMediaStatistic | null>) => {
      state.socialMediaStatistics.statistics = action.payload;
    },
    setStatisticFiltersAC: (state, action: PayloadAction<StatisticDateRangeType>) => {
      state.socialMediaStatistics.filters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setUpdatedBeerAC, (state, action) => {
      state.singleBeer = action.payload;
    });
  },
});

export default beerPreviewSlice;

export const {setSingleBeerAC, setStatisticAC, setStatisticFiltersAC} = beerPreviewSlice.actions;
